import React, { Component } from 'react'
import PropTypes from 'prop-types'

import StyleControl from './style_control'

export const styles = {
  FONT_SIZE_SMALL: {
    fontSize: '0.8em'
  },
  FONT_SIZE_LARGE: {
    fontSize: '1.2em'
  }
}

export default class FontSize extends Component {
  static propTypes = {
    editorState: PropTypes.object.isRequired,
    toggleStyleGroup: PropTypes.func.isRequired
  }

  styleHandlerFor = style => event => {
    event.preventDefault()
    this.props.toggleStyleGroup(styles, style)
  }

  renderControlFor(style) {
    const { editorState } = this.props
    const currentStyle = editorState.getCurrentInlineStyle()
    return (
      <StyleControl
        active={currentStyle.has(style)}
        style={style}
        styling={styles[style]}
        handler={this.styleHandlerFor(style)}>
        A
      </StyleControl>
    )
  }

  render() {
    const { editorState } = this.props
    const currentStyle = editorState.getCurrentInlineStyle()
    const noneActive = !currentStyle.has('FONT_SIZE_SMALL') && !currentStyle.has('FONT_SIZE_LARGE')
    return (
      <div className="control-group">
        {this.renderControlFor('FONT_SIZE_SMALL')}

        <StyleControl
          active={noneActive}
          editorState={editorState}
          handler={this.styleHandlerFor()}>
          A
        </StyleControl>

        {this.renderControlFor('FONT_SIZE_LARGE')}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// client/components/sections/website/settings/Form/RichText/controls/font_size.js